// localStorage can throw (private mode, blocked storage); never let that break the app.
export function readPref(key: string): string | null {
  try {
    return localStorage.getItem(`moot:${key}`)
  } catch {
    return null
  }
}

export function writePref(key: string, value: string | null) {
  try {
    if (value === null) localStorage.removeItem(`moot:${key}`)
    else localStorage.setItem(`moot:${key}`, value)
  } catch {
    // ignore
  }
}
